import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const ActivityFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M20.52 8.89c-.57.33-1.23.54-1.94.54-2.15 0-3.89-1.74-3.89-3.89 0-.76.22-1.46.6-2.05-.12 0-.24-.02-.37-.02H8.86C5.77 3.47 3.24 6 3.24 9.09v5.84c0 3.09 2.53 5.62 5.62 5.62h6.06c3.09 0 5.62-2.53 5.62-5.62V8.9l-.02-.01Zm-3.74 3.74h-1.23l-1.57 3.84c-.09.23-.31.37-.55.37h-.03a.586.586 0 0 1-.54-.44L10.9 9.46l-1.35 2.85c-.1.21-.31.34-.54.34H7.22c-.33 0-.6-.27-.6-.6 0-.33.27-.6.6-.6h1.41l1.88-3.95c.11-.23.34-.36.59-.34a.6.6 0 0 1 .53.43l1.92 6.81 1.06-2.58a.6.6 0 0 1 .55-.37l1.63-.02c.33 0 .6.26.6.59 0 .33-.26.6-.59.61h-.02Z"
        fill={color}
      />
      <Path
        d="M18.58 7.95a2.42 2.42 0 1 0 0-4.84 2.42 2.42 0 0 0 0 4.84Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default ActivityFilled
